export interface LeadOptionsActions {
    canEdit: boolean;
    canDelete: boolean;
    canInsertNegocio: boolean;
}

export class LeadOptions implements LeadOptionsActions {
    canEdit: boolean;
    canDelete: boolean;
    canInsertNegocio: boolean;

    /** Verifica se possui alguma opção habilitada */
    hasAnyOption(): boolean {
        return this.canEdit ||
            this.canDelete ||
            this.canInsertNegocio;
    }
}
